<span [@showSnackbar]="shouldShowSnackbar ? 'show' : 'hide'" class="snackbar">{{ label }}</span>
